var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-table-body-cell',_vm._b({attrs:{"render-when-empty":""}},'iv-base-table-body-cell',{ ..._vm.$attrs, ..._vm.$props },false),[_c('div',{staticClass:"job-user"},[_c('div',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.userName))]),_c('div',{staticClass:"org-name"},[_vm._v(_vm._s(_vm.orgName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }